import type { RouteObject } from 'react-router-dom';
import { PortalPage } from './PortalPage';

/** ポータル：年度ルートの index */
export const routes: RouteObject[] = [{ index: true, element: <PortalPage /> }];
